import { animated } from '@react-spring/web';
import React from 'react';
export function ToastProgress({ life }) {
    return (React.createElement(animated.div, { className: "tw-absolute tw-bottom-0 tw-left-0 tw-h-1 tw-bg-blue-600", "data-testid": "toast-progress", style: { width: life } }));
}
//# sourceMappingURL=ToastProgress.js.map